import React from 'react';
import SourceBadge from '../MatchesPage/SourceBadge';
import { MatchSource } from '../MatchesPage/types';

const MatchIdentity: React.FC<{ source: MatchSource; title: string; subtitle?: string; kickoffAt: string; score?: { home: number; away: number } | null }> = ({ source, title, subtitle, kickoffAt, score }) => (
  <div className="min-w-0">
    <div className="mb-2 flex flex-wrap items-center gap-2"><SourceBadge source={source} /><time className="text-sm text-gray-600 dark:text-gray-300" dateTime={kickoffAt}>{new Date(kickoffAt).toLocaleString()}</time></div>
    <h1 className="break-words text-2xl font-bold text-gray-950 dark:text-white sm:text-3xl">{title}{score && <span className="ml-3 tabular-nums">{score.home}-{score.away}</span>}</h1>
    {subtitle && <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">{subtitle}</p>}
  </div>
);
export default MatchIdentity;
